import { render, staticRenderFns } from "./ModuleCard.vue?vue&type=template&id=181f382b&scoped=true&"
import script from "./ModuleCard.vue?vue&type=script&lang=js&"
export * from "./ModuleCard.vue?vue&type=script&lang=js&"
import style0 from "./ModuleCard.vue?vue&type=style&index=0&id=181f382b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181f382b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VChip,VImg,VList,VListItem,VMenu,VProgressCircular,VProgressLinear,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('181f382b')) {
      api.createRecord('181f382b', component.options)
    } else {
      api.reload('181f382b', component.options)
    }
    module.hot.accept("./ModuleCard.vue?vue&type=template&id=181f382b&scoped=true&", function () {
      api.rerender('181f382b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/ModuleCard.vue"
export default component.exports